import { init } from '@airwallex/components-sdk';

// Unified redirect: Stripe/external return a plain `url`; Airwallex returns
// an intent that must be opened through the Hosted Payment Page SDK.
export async function redirectToPayment(resData) {
  if (!resData) return false;
  if (resData.url) {
    window.location.href = resData.url;
    return true;
  }
  if (resData.provider === 'airwallex' && resData.intent_id && resData.client_secret) {
    const env = resData.env === 'prod' ? 'prod' : 'demo';
    const { payments } = await init({ env, enabledElements: ['payments'] });
    const origin = window.location.origin;
    await payments.redirectToCheckout({
      env,
      mode: 'payment',
      intent_id: resData.intent_id,
      client_secret: resData.client_secret,
      currency: resData.currency || 'GBP',
      country_code: 'GB',
      successUrl: `${origin}/payment/success?session_id=${resData.session_id}`,
      failUrl: `${origin}/payment/cancel`,
      cancelUrl: `${origin}/payment/cancel`,
    });
    return true;
  }
  return false;
}
